export default __webpack_public_path__ + "static/media/WINGS-BNB-BUSD.60210ba7.svg";